module.exports = __webpack_public_path__ + "img/ot-pendle_eth_slp.573d443c.svg";